/* eslint-disable */
import React from 'react'
import http from '../../Component/Interceptor/Interseptor'
import {accounting} from 'accounting'
import {message} from 'antd'
import jMoment from 'moment-jalaali'
import moment from 'moment'
import REPORT_DISPATCH from '../BaseComponent/REPORTDISPATCH'
import {withRouter} from 'react-router-dom'
import '../../printBascketA4.css'
export default class BigBasckets extends React.Component {
  render() {
    let {factors} = this.props

    var totalAmount = 0
    var discountAmount = 0
    var payableAmount = 0

    function convertSefr() {
      totalAmount = 0
      discountAmount = 0
      payableAmount = 0
    }
    return (
      <div className="wrapperBascketA4 p-3" ref={(node) => (this.table = node)}>
        {factors.map((personItem, index) => (
          <div className="item position-relative">
            {personItem.invoice.canceled && (
              <img
                src={require('../../image/cancelMohr.png')}
                className="position-absolute"
                style={{top: 40, left: 0, opacity: 0.5}}
              />
            )}

            <div className="d-flex flex-row justify-content-between  hidden-section-print">
              <span className="font-weight-bold" style={{color: '#000', fontSize: '3em'}}>
                {personItem.invoice.invoiceNum}
              </span>
              <span className="mt-2" style={{color: '#000', fontSize: '1.4em'}}>
                رسید تحویل کالا
              </span>
              <span className="font-weight-bold" style={{color: '#000', fontSize: '3em'}}>
                {jMoment(personItem.planDate).format('jYYYY/jM/jD') +
                  ' , ' +
                  personItem.planTimeFrom.substr(0, 2) +
                  ' - ' +
                  personItem.planTimeTo.substr(0, 2)}
              </span>
            </div>
            {/*<h5 style={{textAlign: 'center',marginTop:'30px'}}>رسید تحویل کالا</h5>*/}
            <table className="printTable resid">
              <tbody>
                <tr>
                  <th>تحویل گیرنده</th>
                  <th>کد مشتری</th>
                  {/* <th>موبایل</th> */}
                  <th>شهر</th>
                  <th>منطقه</th>
                  <th>آدرس</th>
                  <th>تاریخ ثبت سفارش</th>
                  <th>وضعیت</th>
                </tr>
                <tr>
                  <td>{personItem.invoice.recipientName}</td>
                  <td>{personItem.customer.userCode}</td>
                  {/* <td>{(/\+98/g.test(personItem.invoice.mobile))?personItem.invoice.mobile.replace(/\+98/g,'0'):personItem.invoice.mobile}</td> */}
                  <td>{personItem.invoice.city}</td>
                  <td>{personItem.invoice.region}</td>
                  <td className="font-weight-bold" style={{fontSize: '1em'}}>
                    {personItem.invoice.address}
                  </td>
                  <td>{jMoment(personItem.invoice.registerDate).format('jYYYY/jM/jD HH:mm')}</td>
                  <td>{personItem.invoice.paid ? 'پرداخت شده' : 'پرداخت نشده'}</td>
                </tr>
              </tbody>
            </table>
            <table className="printTable secondFactorTable">
              <tbody>
                <tr style={{backgroundColor: '#ededed'}}>
                  <th>ردیف</th>
                  <th>کد کالا</th>
                  <th>شرح</th>
                  <th style={{fontSize: '0.7em'}}>تامین کننده (فروشنده)</th>
                  <th>تعداد</th>
                  <th>واحد</th>
                  <th>قیمت واحد </th>
                  <th>جمع کل </th>
                  <th>تخفیف </th>
                  <th>قابل پرداخت </th>
                </tr>
                {convertSefr()}
                {personItem.items.map((subItem, index) => (
                  <tr key={'i' + index}>
                    <th>{index + 1}</th>
                    <td>{subItem.productCode}</td>
                    <td>{subItem.productName}</td>
                    <td style={{fontSize: '0.7em'}}>{subItem.providerName}</td>
                    <td>{subItem.quantity}</td>
                    <td style={{fontSize: '0.7em'}}>{subItem.productUnitTitle}</td>
                    <td>{accounting.formatMoney(subItem.unitPrice, '', ',')}</td>
                    <td>{accounting.formatMoney(subItem.totalAmount, '', ',')}</td>
                    <td>{accounting.formatMoney(subItem.discountAmount, '', ',')}</td>
                    <td>{accounting.formatMoney(subItem.payableAmount, '', ',')}</td>
                  </tr>
                ))}
                <tr>
                  <td colSpan={7}>مجموع</td>
                  <td style={{fontWeight: '600'}}>
                    {accounting.formatMoney(personItem.deliveryInfo.totalAmount, '', ',')}
                  </td>
                  <td style={{fontWeight: '600'}}>
                    {accounting.formatMoney(personItem.deliveryInfo.discountAmount, '', ',')}
                  </td>
                  <td style={{fontWeight: '600'}}>
                    {accounting.formatMoney(personItem.deliveryInfo.payableAmount, '', ',')}
                  </td>
                </tr>
              </tbody>
            </table>
            <table className="printTable lastInfoTable">
              <tbody>
                <tr>
                  {/* <td className='small'>شیوه ارسال</td>
                                <td className='small'>پرداخت در محل</td>
                                <td className='small'>تاریخ تحویل</td> */}
                  <td className="small">رساننده</td>
                  <td className="big">
                    <span className="mx-1">توضیحات</span>
                    <span className="" style={{color: '#000', fontSize: '0.7em'}}>
                      (تمامی مبالغ به ریال میباشد)
                    </span>
                  </td>
                  {personItem.totalInfo.previousDebt ? <td className="small">بدهی سفارش‌های قبلی</td> : null}
                  {personItem.totalInfo.orderDebt ? <td className="small">بدهی مرسوله‌های قبلی</td> : null}
                  <td className="small">مبلغ رزرو </td>
                  {personItem.totalInfo.parcelUnverifiedPaymentAmount ? (
                    <td className="small">پرداختی‌های تایید نشده</td>
                  ) : null}
                  <td className="small">قابل پرداخت نهایی </td>
                </tr>
                <tr>
                  {/* <td>{personItem.deliveryMethodTitle}</td>
                                <td style={{minWidth:'100px'}}>{personItem.invoice.payOnDelivery ? 'بله' : 'خیر'}</td>
                                <td style={{minWidth:'150px'}}>{jMoment(personItem.planDate).format('jYYYY/jM/jD') + ' , ' + personItem.planTimeFrom.substr(0, 5) + ' - ' + personItem.planTimeTo.substr(0, 5)}</td> */}
                  <td style={{fontWeight: '600', minWidth: '150px'}}>
                    {personItem.driver == null ? '-' : personItem.driver.name}
                  </td>
                  <td>
                    <span className="d-block">{personItem.invoice.description}</span>
                  </td>
                  {personItem.totalInfo.previousDebt ? (
                    <td>{accounting.formatMoney(personItem.totalInfo.previousDebt, '', ',')}</td>
                  ) : null}

                  {personItem.totalInfo.orderDebt ? (
                    <td>{accounting.formatMoney(personItem.totalInfo.orderDebt, '', ',')}</td>
                  ) : null}
                  <td style={{fontWeight: '600', fontSize: '0.7em'}} className="ltrTd">
                    {accounting.formatMoney(personItem.totalInfo.reserveAmount, '', ',')}
                  </td>
                  {personItem.totalInfo.parcelUnverifiedPaymentAmount ? (
                    <td style={{fontWeight: '600'}} className="ltrTd">
                      {accounting.formatMoney(personItem.totalInfo.parcelUnverifiedPaymentAmount, '', ',')}
                    </td>
                  ) : null}
                  <td style={{fontWeight: '600'}} className="ltrTd">
                    {accounting.formatMoney(personItem.totalInfo.payableAmount, '', ',')}
                  </td>
                </tr>
              </tbody>
            </table>
            <div className="hideInvoiceNum d-flex flex-row justify-content-between">
              <span className="font-weight-bold" style={{color: '#000', fontSize: '2em'}}>
                شماره فاکتور :{personItem.invoice.invoiceNum}
              </span>
              <span>{'زمان چاپ : ' + this.props.printDate}</span>
            </div>
            <div>
              <p className="mb-0">
                ارائه کد تحویل , به منزله‌ی تحویل سالم و کامل محصول میباشد.لطفا در زمان تحویل دقت فرمایید.
              </p>
            </div>
            <h1 className="breakHr" />
          </div>
        ))}
      </div>
    )
  }
}
